import React, { useCallback } from 'react'
import { Button, Space } from 'antd'
import { noop } from 'lodash'
import PropTypes from 'prop-types'

const ToggleConfirmButtons = ({
  showConfirm,
  disableConfirm,
  onToggle,
  onConfirm,
  operationText,
}) => {
  const handleToggleClick = useCallback(() => onToggle(), [onToggle])

  return (
    <Space>
      <Button onClick={handleToggleClick}>
        {showConfirm ? 'Cancel' : 'Toggle'} {operationText}
      </Button>
      {showConfirm && (
        <Button disabled={disableConfirm} type="primary" onClick={onConfirm}>
          Confirm {operationText}
        </Button>
      )}
    </Space>
  )
}

ToggleConfirmButtons.propTypes = {
  showConfirm: PropTypes.bool,
  disableConfirm: PropTypes.bool,
  onToggle: PropTypes.func,
  onConfirm: PropTypes.func,
  operationText: PropTypes.string.isRequired,
}

ToggleConfirmButtons.defaultProps = {
  showConfirm: true,
  disableConfirm: false,
  onToggle: noop,
  onConfirm: noop,
}

export default ToggleConfirmButtons
